let sticky_target, sticky_distance, sticky_lock, scroll_pos_prev;

document.addEventListener("DOMContentLoaded", function () {
	sticky_target = document.getElementsByClassName('sticky-nav')[0];
	sticky_distance = window.innerHeight;

	sticky_lock = false;
	scroll_pos_prev;

	if(sticky_target) {
		let debounce = require('debounce');

		window.addEventListener('scroll', debounce(function() {
			toggle_sticky_nav();
		}, 7));
	}
});

export function toggle_sticky_nav() {

	//if the mobile menu is opened, we shouldn't do anything
	if(document.body.classList.contains('mobile-menu-active')) {

		//so bail early
		return;
	}

	let scroll_pos = window.pageYOffset;
	let scroll_up = sticky_target.classList.contains('sticky-nav-scrollup');
	let scroll_direction = scroll_pos > scroll_pos_prev ? 'down' : 'up';
	let scroll_threshold = scroll_direction == 'up' ? (scroll_pos_prev - scroll_pos > 7) : (scroll_pos - scroll_pos_prev > 7);

	if(!sticky_lock && (scroll_pos >= sticky_distance)) {

		if(!scroll_up || scroll_up && scroll_direction == 'up' && scroll_threshold) {

			let sticky_styles = window.getComputedStyle(sticky_target);

			//if the element is relative, we need to add an offset
			if(sticky_styles.getPropertyValue('position') == 'static' || sticky_styles.getPropertyValue('position') == 'relative') {
				apply_header_offset(sticky_target);
                document.body.dataset.sticky = 'true';
			}

			sticky_target.classList.add('sticky-nav-active');
			sticky_target.classList.add('sticky-nav-transition-enter');
			sticky_lock = true;

			setTimeout(function() {
				sticky_target.classList.remove('sticky-nav-transition-enter');
			}, 100);
		}
	} else if(sticky_lock && (scroll_pos < sticky_distance) || scroll_up && scroll_direction == 'down' && scroll_threshold) {
		sticky_target.classList.add('sticky-nav-transition-exit');

        document.body.dataset.sticky = 'false';

		setTimeout(function() {
			remove_header_offset();
			sticky_target.classList.remove('sticky-nav-transition-exit');
			sticky_target.classList.remove('sticky-nav-active');
			sticky_lock = false;
		}, 100);
	}

	scroll_pos_prev = scroll_pos;
}

export function apply_header_offset(sticky_target) {

	if(!sticky_target) {
		sticky_target = document.getElementsByTagName('header')[0];
	}

	let sticky_height = sticky_target.offsetHeight;

	document.body.style.paddingTop = sticky_height + 'px';
}

export function remove_header_offset(sticky_target) {
	document.body.style.paddingTop = '';
}